import { useMediaQuery } from "@/hooks/useMediaQuery";

/** True nur bei Maus/Trackpad – nicht auf Smartphones (kein sinnvolles Hover). */
export function useHoverCapable(): boolean {
  return useMediaQuery("(hover: hover) and (pointer: fine)");
}
